/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var LogoMicrosoftIcon20Solid = forwardRef('LogoMicrosoftIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M9.25 3H3v6.25h6.25V3Z" }),
        React.createElement("path", { d: "M9.25 10.75H3V17h6.25v-6.25Z" }),
        React.createElement("path", { d: "M10.75 3H17v6.25h-6.25V3Z" }),
        React.createElement("path", { d: "M17 10.75h-6.25V17H17v-6.25Z" })));
});
